<div>
  <table class="lookupContainer">
    <tr>
      <td>
        <mat-label style='font-size: 16px; font-weight: bold;'>Quick Lookup: </mat-label>
      </td>
    </tr>
    <tr>
      <td>
      <input kendoTextBox type="number" min="0.01">
      <button mat-raised-button style="margin-left: 10px;">View</button>
      </td>
    </tr>
    <tr>
      <td>
      Search By:
      </td>
    </tr>
    <mat-radio-group class="lookup-radio-group">
    <tr>
      <td>
      <mat-radio-button value='I' checked>Invoice Number</mat-radio-button>
      </td>
    </tr>
    <tr>
      <td>
      <mat-radio-button value='O'>Order Number</mat-radio-button>
      </td>
    </tr>
  </mat-radio-group>
  </table>
</div>
